module.exports = __webpack_public_path__ + "img/livingWage@2x.54691adb.webp";